import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import dtes from './slices/dteSlice/dteSlice';
import usuario from './slices/usuarioSlice';
import operacion from './slices/operacionSlice';
import operaciones from './slices/operacionesSlice/operacionesSlice';
import detalleOperacion from './slices/detalleOperacionSlice';
import mantenedorCuentas from './slices/mantenedorCuentasSlice';
import clientes from './slices/clientesSlice/clientesSlice';
import { dteApi } from './services/dteApi';
import { operacionesApi } from './services/operacionesApi';

const rootReducer = combineReducers({
  usuario,
  dtes,
  operacion,
  operaciones,
  detalleOperacion,
  mantenedorCuentas,
  clientes,
  [dteApi.reducerPath]: dteApi.reducer,
  [operacionesApi.reducerPath]: operacionesApi.reducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['usuario'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (gDM) =>
    gDM({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([dteApi.middleware, operacionesApi.middleware]),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
